import mapFunction from './mapResources';

export default mapFunction('business_trips_cars', {
    isFetching: false,
    items: [] 
});
